import React, { useContext, useEffect } from "react";
import { useAppConext } from "./AppContext";
import { ColorModeContext } from "./ColorModeContext";
import { ThemeProvider, createTheme, useMediaQuery } from "@mui/material";
import theme from '../theme/theme';
import { lightPallette } from '../theme/pallette'
import LoadingProgress from "../components/LoadingProgress";

export const useColorModeContext = () => {
    return useContext(ColorModeContext);
};

const ColorModeContextProvider = ({children}) => {
    const { branding, init } = useAppConext();

    const [pallete, setPallete] = React.useState(lightPallette);
    const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

    const [mode, setMode] = React.useState('light');
    const [currentMode, setCurrentMode] = React.useState(null)

    useEffect(() => {
        if (branding) {
            setPallete(mode === 'light' ? branding?.themeColor?.light : branding?.themeColor?.dark);
        }
    }, [mode, init, branding]);

    const colorMode = React.useMemo(() => ({
        toggleColorMode: (mode) => {
            if (mode === 'auto') {
                setMode(prefersDarkMode ? 'dark' : 'light');
            } else {
                setMode(mode);
            }
            setCurrentMode(mode);
        },
        currentMode: currentMode
    }), [currentMode, prefersDarkMode]);

    useEffect(() => {
        if (currentMode !== null){
            if (currentMode === 'auto'){
                colorMode.toggleColorMode('auto');
            }
            localStorage.setItem('displayMode', currentMode);
        }
    }, [prefersDarkMode, currentMode, colorMode]);

    useEffect(() => {
        const displayMode = localStorage.getItem('displayMode');
        if (displayMode) {
            colorMode.toggleColorMode(displayMode);
        } else {
            colorMode.toggleColorMode('light');
        }
    }, [colorMode]);

    const appTheme = React.useMemo(() => {
        if (pallete) {
            return createTheme({
                ...theme,
                palette: {
                    ...pallete,
                    mode
                },
            });
        }
    }, [mode, pallete]);

    return (
        <ColorModeContext.Provider value={{
            appTheme,
            currentMode,
            colorMode,
            toggleColorMode: colorMode.toggleColorMode
        }}>
            {(init) ? (
                <ThemeProvider theme={appTheme}>
                    {children}
                </ThemeProvider>
            ) : (
                <LoadingProgress open />
            )}
        </ColorModeContext.Provider>
    );
};

export default ColorModeContextProvider;